import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAngleUpSmall = function SvgAngleUpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8839 8.94448C12.3956 8.45631 11.6042 8.45636 11.1161 8.94447L11.1161 8.94449L4.53033 15.5302C4.23743 15.8231 3.76256 15.8231 3.46967 15.5302C3.17678 15.2373 3.17678 14.7625 3.46967 14.4696L10.0555 7.88384C10.0555 7.88384 10.0555 7.88383 10.0555 7.88383C11.1294 6.80986 12.8705 6.80992 13.9445 7.8838L13.9445 7.88382L20.5303 14.4696C20.8232 14.7625 20.8232 15.2373 20.5303 15.5302C20.2374 15.8231 19.7626 15.8231 19.4697 15.5302L12.8839 8.9445C12.8839 8.94449 12.8839 8.94449 12.8839 8.94448Z"
  })));
};

export { SvgAngleUpSmall as ReactComponent };
//# sourceMappingURL=angle-up-small.svg.js.map
